// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#consent-box h3 {
  font-size: 16px;
}
#consent-box h4 {
  font-size: 14px;
  color: #000 !important;
}
#consent-box table {
  margin-bottom: 1rem;
}
#consent-box table th, #consent-box table td {
  border: 1px solid #606060;
  padding: 0.25rem 0.5rem;
}
#consent-box table tr {
  vertical-align: baseline;
}
#consent-box table p {
  margin-bottom: 0;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
